import styled from "styled-components";

export const RankColumn = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-shrink: 0;
    margin-left: 30px;
`;

export const RankCell = styled(RankColumn)`
    font-size: 12px;
    font-weight: bold;
    margin-left: 0;
`;

export const UnrankedCell = styled(RankColumn)`
    font-size: 9px;
    font-weight: bold;
    margin-left: 0;
`;